// extracted by mini-css-extract-plugin
export default {"actionItem":"school-action-item_actionItem__ks2Bp","content":"school-action-item_content__kXDhY","link":"school-action-item_link__RAwbU"};